import { Component, OnInit } from '@angular/core';
import { DashboardCreanceService } from '../../core/service/suiviPortefeuille/dashboard-creance.service';
import { first } from "rxjs/operators";
import { ChartViewDTO } from '../../core/model/chart_view/chart-view-dto';
import * as Highcharts from "highcharts";

@Component({
  selector: "app-creance-restructure",
  templateUrl: "./creance-restructure.component.html",
  styleUrls: ["./creance-restructure.component.scss"]
})
export class CreanceRestructureComponent implements OnInit {
  highcharts = Highcharts;

  nombreRestructurationByPeriode: ChartViewDTO;
  chartOptionsSuiviByPeriode: any;

  quantiteByPeriode: ChartViewDTO;
  chartOptionsQuantiteByPeriode: any;

  constructor(private _dashboardCreanceService: DashboardCreanceService) {}

  ngOnInit() {
    this.nombreDossierContentieuxFiltrerSurPeriode();
    this.quantiteDossierContentieuxSurLes6DerniersMois();
  }

  nombreDossierContentieuxFiltrerSurPeriode() {
    this._dashboardCreanceService
      .nombreDossierContentieuxFiltrerSurPeriode()
      .pipe(first())
      .subscribe(
        response => {
          this.nombreRestructurationByPeriode = response;

          this.chartOptionsSuiviByPeriode = {
            chart: {
              type: "spline"
            },
            title: {
              text: "Evolution des dossiers restructurés sur les 12 derniers mois"
            },
            subtitle: {
              text: null
            },
            xAxis: {
              categories: this.nombreRestructurationByPeriode.categories
            },
            yAxis: {
              title: {
                text: "Jour(s)"
              }
            },
            tooltip: {
              valueSuffix: null
            },

            legend: {
              layout: "vertical",
              align: "right",
              verticalAlign: "top",
              x: 0,
              y: 100,
              floating: false,
              borderWidth: 1,

              backgroundColor: "#FFFFFF",
              shadow: true
            },

            series: this.nombreRestructurationByPeriode.series
          };
        },
        error => {
          console.log(error);
        }
      );
  }

  quantiteDossierContentieuxSurLes6DerniersMois() {
    this._dashboardCreanceService
      .quantiteDossierContentieuxSurLes6DerniersMois()
      .pipe(first())
      .subscribe(
        response => {
          this.quantiteByPeriode = response;

          this.chartOptionsQuantiteByPeriode = {
            chart: {
              type: "column" // Changer le type en "column"
            },
            title: {
              text: "Evolution des dossiers restructurés par marché sur les 12 derniers mois"
            },
            subtitle: {
              text: null
            },
            xAxis: {
              categories: this.quantiteByPeriode.categories
            },
            yAxis: {
              title: {
                text: "Qté"
              }
            },
            tooltip: {
              valueSuffix: null
            },

            legend: {
              layout: "vertical",
              align: "right",
              verticalAlign: "top",
              x: 0,
              y: 100,
              floating: false,
              borderWidth: 1,

              backgroundColor: "#FFFFFF",
              shadow: true
            },

            plotOptions: {
              column: {
                stacking: "normal", // Ajouter cette ligne pour empiler les colonnes
                dataLabels: {
                  enabled: true
                }
              }
            },

            series: this.quantiteByPeriode.series
          };
        },
        error => {
          console.log(error);
        }
      );
  }
}
